import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

type SupportRoutingRulesPatternListProps = {
  label: string;
  description: string;
  values: string[];
  placeholder: string;
  disabled?: boolean;
  onChange: (values: string[]) => void;
};

export function SupportRoutingRulesPatternList({
  label,
  description,
  values,
  placeholder,
  disabled = false,
  onChange,
}: SupportRoutingRulesPatternListProps) {
  const rows = values.length > 0 ? values : [''];

  function updateRow(index: number, nextValue: string): void {
    const next = [...rows];
    next[index] = nextValue;
    onChange(next);
  }

  function removeRow(index: number): void {
    const next = rows.filter((_, itemIndex) => itemIndex !== index);
    onChange(next.length > 0 ? next : []);
  }

  return (
    <div className="rounded-lg border border-secondary-200 bg-white p-3">
      <div className="mb-2">
        <p className="text-sm font-medium text-secondary-900">{label}</p>
        <p className="mt-0.5 text-xs text-secondary-500">{description}</p>
      </div>
      <div className="space-y-2">
        {rows.map((value, index) => (
          <div key={`pattern-${index}`} className="flex gap-2">
            <input
              className="erp-input-compact w-full"
              value={value}
              disabled={disabled}
              placeholder={placeholder}
              onChange={(event) => updateRow(index, event.target.value)}
            />
            <button
              type="button"
              className="erp-btn-secondary erp-btn-sm shrink-0"
              disabled={disabled || (rows.length <= 1 && !value.trim())}
              onClick={() => removeRow(index)}
              aria-label="Remover padrão"
            >
              <TrashIcon className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        className="erp-btn-secondary erp-btn-sm mt-2"
        disabled={disabled}
        onClick={() => onChange([...rows, ''])}
      >
        <PlusIcon className="mr-1 inline h-4 w-4" />
        Adicionar padrão
      </button>
    </div>
  );
}
